import i18n, { i18n as I18nInstance } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { defaultLang } from './langConfig'

export const createAppI18n = (): I18nInstance => {
  const instance = i18n.createInstance()

  instance
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {},
      fallbackLng: defaultLang.value,
      debug: false,
      keySeparator: '.',
      react: {
        useSuspense: true,
        bindI18n: 'languageChanged languageChanging'
      },
      interpolation: {
        escapeValue: false,
        formatSeparator: '.'
      },
      detection: {
        order: ['localStorage', 'sessionStorage'],
        lookupLocalStorage: 'storedLng',
        lookupSessionStorage: 'storedLng',
        caches: ['localStorage', 'sessionStorage']
      }
    })
    .catch(console.error)

  return instance
}
